import * as angular from 'angular';
import { HasErrorElemCtrl } from 'app/_util/has-error-elem.directive';

class HasError implements ng.IDirective {
    public restrict = 'A';
    public scope = false;
    public require = ['^^form', 'ngModel', '^pkpHasErrorElem'];

    constructor() {}

    public link = (
        scope: ng.IScope,
        instanceElement: JQuery,
        instanceAttributes: ng.IAttributes,
        ctrls: [ng.IFormController, ng.INgModelController, HasErrorElemCtrl]
    ) => {
        const ngFormCtrl: ng.IFormController = ctrls[0];
        const ngModelCtrl: ng.INgModelController = ctrls[1];
        const hasErrorElemCtrl: HasErrorElemCtrl = ctrls[2];

        if (ngModelCtrl == null) {
            return;
        }

        hasErrorElemCtrl.registerDoCheckListener(
            ngFormCtrl,
            ngModelCtrl,
            instanceAttributes.pkpHasError
        );
    };
}

angular.module('app').directive('pkpHasError', () => new HasError());
